import { createContext, useContext, type ReactNode } from 'react'
import { useKnowledgeBaseSelection } from '~/features/knowledge-bases/hooks/useKnowledgeBaseSelection'
import type { KnowledgeSource } from '../../types'

type SelectionState = {
  knowledgeSource: string[]
  webPageSource: string[]
}

type SelectionContextValue = {
  selectedKnowledgeSources: SelectionState
  setSelectedKnowledgeSources: (selection: SelectionState) => void
  currentIndex: number
  setCurrentIndex: (index: number) => void
  handleMultiSelection: (index: number) => void
  selectedKnowledgeSourcesCount: number
  clearSelectedKnowledgeSources: () => void
}

const KnowledgeSourceSelectionContext = createContext<SelectionContextValue | null>(null)

type KnowledgeSourceSelectionProviderProps = {
  children: ReactNode
  knowledgeSources: KnowledgeSource[]
  dsIds: string[]
}

export const KnowledgeSourceSelectionProvider = ({
  children,
  knowledgeSources,
  dsIds,
}: KnowledgeSourceSelectionProviderProps) => {
  const selectionState = useKnowledgeBaseSelection(knowledgeSources, dsIds)

  return (
    <KnowledgeSourceSelectionContext.Provider value={selectionState}>
      {children}
    </KnowledgeSourceSelectionContext.Provider>
  )
}

export const useKnowledgeSourceSelection = () => {
  const context = useContext(KnowledgeSourceSelectionContext)
  if (!context) {
    throw new Error('useKnowledgeSourceSelection must be used within KnowledgeSourceSelectionProvider')
  }
  return context
}
